// extracted by mini-css-extract-plugin
module.exports = {"page":"Page-module--page--2zOls","page__inner":"Page-module--page__inner--2TmOU","page__title":"Page-module--page__title--bpbOt","page__body":"Page-module--page__body--Sdw0a"};